import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

DialogTransactionDetailView.propTypes = {
    item: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogTransactionDetailView({ item }) {
    // MARK: ---- PROPERTIES ----
    const row = item;

    return (
        <div className="p-4" style={{ backgroundColor: AppColors.gray[100] }}>
            <div className='pb-2' style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                Thông tin cơ bản
            </div>
            {UIHelper.buildSectionCard(
                <div
                    className=""
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '5px',
                        overflow: 'hidden',
                    }}
                >
                    {UIHelper.buildCardCellItem(
                        'Loại giao dịch',
                        row?.forRole
                            ? row.forRole === 'WITHDRAW'
                                ? 'Rút tiền'
                                : 'Cộng tiền'
                            : ''
                    )}
                    {UIHelper.buildCardCellItem(
                        'Mã giao dịch',
                        row?.agencyTransactionId
                    )}
                    {UIHelper.buildCardCellItem(
                        'Người thụ hưởng',
                        row?.payment?.bankBeneficiary
                    )}
                    {UIHelper.buildCardCellItem(
                        'Tài khoản thụ hưởng',
                        row?.payment?.bankAccount
                    )}
                    {UIHelper.buildCardCellItem(
                        'Ngân hàng',
                        row?.payment?.bankName
                    )}
                    {UIHelper.buildCardCellItem(
                        'Thời gian yêu cầu',
                        Utils.formatDateTimeToString(row?.createdAt)
                    )}
                    {UIHelper.buildCardCellItem(
                        'Thời gian thanh toán',
                        Utils.formatDateTimeToString(row?.updatedAt)
                    )}
                    {UIHelper.buildCardCellItem(
                        'Số tiền (VNĐ)',
                        row?.forRole
                            ? row.forRole === 'WITHDRAW'
                                ? Utils.formatNumber(row?.amount)
                                : '+' + Utils.formatNumber(row?.amount)
                            : '',
                        () => { }

                    )}
                    {UIHelper.buildCardCellItem(
                        'Số dư ví (VNĐ)',
                        row?.endingBalance ? Utils.formatNumber(row?.endingBalance) : '',
                    )}
                    {UIHelper.buildCardCellItem(
                        'Trạng thái',
                        row?.payment?.status && (
                            <KTLabel
                                text={AgencyHelper.Utils.getTransactionStatusName(row?.payment?.status)}
                                isInline={true}
                                size={KTLabelSize.medium}
                                additionalClassName={`label-light-${AgencyHelper.Utils.getTransactionStatusColor(row?.payment?.status)}`}
                            />
                        ),
                        null,
                        false
                    )}
                </div>
            )}

            <div className='pt-4 pb-2' style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                Mô tả
            </div>
            {UIHelper.buildSectionCard(
                <div
                    className=""
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '5px',
                        overflow: 'hidden',
                    }}
                >
                    <KTFormTextArea
                        rows={3}
                        name="Mô tả"
                        value={row?.description}
                    />
                </div>
            )}
        </div>
    );
}

export default DialogTransactionDetailView;
